import * as constants from '@gef-ui/validations/constants';

import { MaxLengths } from 'constants/forms';

const regexNumber = /^[0-9]*$/;
const businessCaseLastCharacter = ['A'];
const regexDocumentId = /^[0-9a-zA-Z]*$/;
const regexDocumentIdAttachment = /^[dD]?\d+$/;
const regexTitle = /^[a-zA-Zá-žÁ-Ž. -]*$/;
const regexName = /^[0-9a-zA-Zá-žÁ-Ž. \.\-\&\,]*$/;
const regexClaimNumber = /^[0-9a-zA-Zá-žÁ-Ž. \.\-\/]*$/;
const regexNameWithAsterisk = /^[0-9a-zA-Zá-žÁ-Ž \.\-\&\,\*]*$/;
const regexSurname = /^[0-9a-zA-Zá-žÁ-Ž \.\-\&\,]*$/;
const regexSurnameAsterisk = /^[0-9a-zA-Zá-žÁ-Ž \.\-\&\,\*]*$/;
const regexBusinessName = /^[0-9a-zA-Zá-žÁ-Ž.\-&,!@#$()?+:\s]*$/;
const regexAdministration = /^[0-9a-zA-Zá-žÁ-Ž \-\.\&\,]*$/;
const regexProposal = '^[0-9a-zA-Zá-žÁ-Ž-.\\\\/]*$';
const regexLogin = /^[0-9a-zA-Zá-žÁ-Ž\\_.]*$/;
const regexDate = /^[0-9./]+$/;
const regexZipCode = /^[0-9]*$/;
const regexMunicipality = /^[a-zA-Zá-žÁ-Ž0-9. -]*$/;
const regexStreetNumber = /^[a-zA-Zá-žÁ-Ž0-9. \-/]*$/;
const regexPhoneNumber = /^(?:(?:(?:\+|00)[0-9]{1,3})[0-9]{8,9}|[0-9]{9})$/;
const regexNote = /^[^\"\']*$/;
const regexNotAllowedSpecialCharacters = /^[^~°!?@#$%=^{}\[\]|\\]*$/;
// not used in forms, but throughout application, when exporting xls etc.
// eslint-disable-next-line
export const regexFileName = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
// eslint-disable-next-line max-len
const emailRegExp =
	/^[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@[a-zA-Z0-9]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*\.[a-zA-Z0-9]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?$/;
const allowedCharacters = 'allowedCharacters';
const allowedCharactersDocumentId = 'allowedCharactersDocumentId';
const allowedCharactersDocumentIdAttachment = 'allowedCharactersDocumentIdAttachment';
const allowedCharactersDate = 'allowedCharactersDate';
const allowedCharactersClaimNo = 'allowedCharactersClaimNo';
const allowedOnlyNumbers = 'allowedOnlyNumbers';
const allowedOnlyNumbersAndCharacters = 'allowedOnlyNumbersAndCharacters';
const allowedCharactersBusinessCase = 'allowedCharactersBusinessCase';
const allowedCharactersPhoneNumber = 'allowedCharactersPhoneNumber';
const allowedCharactersTitle = 'allowedCharactersTitle';
const allowedCharactersName = 'allowedCharactersName';
const allowedCharactersNameAsterisk = 'allowedCharactersNameAsterisk';
const allowedCharactersSurname = 'allowedCharactersSurname';
const allowedCharactersSurnameAsterisk = 'allowedCharactersSurnameAsterisk';
const allowedCharactersBusinessName = 'allowedCharactersBusinessName';
const allowedCharactersLogin = 'allowedCharactersLogin';
const allowedCharactersAdministration = 'allowedCharactersAdministration';
const allowedCharactersMunicipality = 'allowedCharactersMunicipality';
const allowedCharactersStreet = 'allowedCharactersStreet';
const allowedCharactersStreetNumber = 'allowedCharactersStreetNumber';
const allowedCharactersEmail = 'allowedCharactersEmail';
const allowedCharactersNote = 'allowedCharactersNote';
const allowedCharactersProductPP = 'allowedCharactersProductPP';
const notAllowedSpecialCharacters = 'notAllowedSpecialCharacters';
const notAllowedAllNullsMsg = 'notAllowedAllNulls';
const wrongPSNumber = 'wrongPSNumber';
const wrongFormat = 'wrongFormat';
const wrongFormatWithExample = 'wrongFormatWithExample';
const datesWrongOrder = 'datesWrongOrder';
const greaterThanZero = 'greaterThanZero';
const lengthMax = 'lengthMax';
const lengthExactUnderFour = 'lengthExactUnderFour';
const lengthBetweenNumber = 'lengthBetweenNumber';

const notAllowedAllNulls = (msg) => ({
	functionName: 'notAllowedAllNulls',
	args: {
		msg,
	},
});

const exactLength = (length, msg = 'lengthExact') => ({
	functionName: 'exactLength',
	args: {
		msg,
		length,
	},
});

const hasLengthBetween = (min, max, msg = 'lengthBetween') => ({
	functionName: 'hasLengthBetween',
	args: {
		msg,
		min,
		max,
	},
});

const domainMaxLength = (max, msg) => ({
	functionName: 'domainMaxLength',
	args: {
		max,
		msg,
	},
});

const notAllowedCharacters = (reg, msg) => ({
	functionName: 'notAllowedCharacters',
	args: {
		msg,
		reg,
	},
});

const notAllowedCharactersFromTo = (reg, msg, from, to) => ({
	functionName: 'notAllowedCharactersFromTo',
	args: {
		reg,
		msg,
		from,
		to,
	},
});

const allowedLastCharacterNumberOrLetter = (reg, msg, allowedCharacters, lastNum) => ({
	functionName: 'allowedLastCharacterNumberOrLetter',
	args: {
		reg,
		msg,
		allowedCharacters,
		lastNum,
	},
});

const checkValidBusinessCaseNumber = (msg) => ({
	functionName: 'checkValidBusinessCaseNumber',
	args: {
		msg,
	},
});

const allowedNumberOfAsterisk = (max, msg = 'oneAsterisk') => ({
	functionName: 'asteriskLimit',
	args: {
		msg,
		max,
	},
});

const asteriskAfterThreeSymbols = (msg = 'asteriskInFirstThreeSymbols') => ({
	functionName: 'asteriskAfterThreeSymbols',
	args: {
		msg,
	},
});

const isValidCDV = (msg) => ({
	functionName: 'isValidCDV',
	args: {
		msg,
	},
	severity: constants.severity.WARNING,
});

const dayMonthValid = (msg) => ({
	functionName: 'dayMonthValid',
	args: {
		msg,
	},
	severity: constants.severity.ERROR,
});
const yearValid = (msg) => ({
	functionName: 'yearValid',
	args: {
		msg,
	},
	severity: constants.severity.ERROR,
});

const dayMonthsOrder = (from, to) => ({
	functionName: 'dayMonthFromGreaterThanDayMonthTo',
	args: {
		from,
		to,
		msg: datesWrongOrder,
	},
	severity: constants.severity.ERROR,
});

const yearsOrder = (from, to) => ({
	functionName: 'compareFieldValues',
	args: {
		from,
		to,
		msg: datesWrongOrder,
	},
	severity: constants.severity.ERROR,
});

const decimalLength = (length, msg) => ({
	functionName: 'decimalLength',
	args: {
		msg,
		length,
	},
	severity: constants.severity.ERROR,
});

const isGreaterThan = (value, msg) => ({
	functionName: 'isGreaterThan',
	args: {
		msg,
		value,
	},
	severity: constants.severity.ERROR,
});

const isDecimalNumberNotGreaterThan = (value, msg) => ({
	functionName: 'isDecimalNumberNotGreaterThan',
	args: {
		msg,
		value,
	},
	severity: constants.severity.ERROR,
});

export const note = [notAllowedCharacters(regexNote, allowedCharactersNote), hasLengthBetween(2, 2000)];

export const noteTask = [notAllowedCharacters(regexNote, allowedCharactersNote), hasLengthBetween(2, 4000)];

export const noteSemaphore = [notAllowedCharacters(regexNotAllowedSpecialCharacters, notAllowedSpecialCharacters)];

export const documentId = [notAllowedCharacters(regexDocumentId, allowedCharactersDocumentId), hasLengthBetween(0, 20)];

export const documentIdAttachment = [
	notAllowedCharacters(regexDocumentIdAttachment, allowedCharactersDocumentIdAttachment),
	hasLengthBetween(0, 19),
];

export const title = [notAllowedCharacters(regexTitle, allowedCharactersTitle)];

export const login = [notAllowedCharacters(regexLogin, allowedCharactersLogin), hasLengthBetween(5, 75)];

export const agencyNumber = [notAllowedCharacters(regexNumber, allowedCharacters), hasLengthBetween(3, 8)];

export const date = [notAllowedCharacters(regexDate, allowedCharactersDate), hasLengthBetween(6, 10)];

export const PSNumber = [notAllowedCharacters(regexNumber, allowedCharacters), isValidCDV(wrongPSNumber)];

export const orderPSNumber = [notAllowedCharacters(regexNumber, allowedCharacters), isGreaterThan(0, greaterThanZero)];

export const sellerInOrAgentNumber = [notAllowedCharacters(regexNumber, allowedCharacters), hasLengthBetween(3, 9)];

export const sellerInNumber = [notAllowedCharacters(regexNumber, allowedCharacters), exactLength(9)];

export const proposalNumber = [notAllowedCharacters(regexProposal, allowedCharacters), hasLengthBetween(7, 20)];

export const claimNumberCP = [
	notAllowedCharacters(regexClaimNumber, allowedCharactersClaimNo),
	hasLengthBetween(4, 20),
	notAllowedAllNulls(notAllowedAllNullsMsg),
];

export const clientSurname = [notAllowedCharacters(regexSurname, allowedCharactersSurname), hasLengthBetween(2, 100)];

export const clientName = [notAllowedCharacters(regexName, allowedCharactersName), hasLengthBetween(2, 50)];

export const clientSurnameWithAsterisk = [
	notAllowedCharacters(regexSurnameAsterisk, allowedCharactersSurnameAsterisk),
	hasLengthBetween(2, 100),
	allowedNumberOfAsterisk(1),
	asteriskAfterThreeSymbols(),
];

export const clientNameWithAsterisk = [
	notAllowedCharacters(regexNameWithAsterisk, allowedCharactersNameAsterisk),
	hasLengthBetween(2, 50),
	allowedNumberOfAsterisk(1),
	asteriskAfterThreeSymbols(),
];

export const businessName = [
	notAllowedCharacters(regexBusinessName, allowedCharactersBusinessName),
	hasLengthBetween(3, 128),
];

export const companyName = [
	notAllowedCharacters(regexNotAllowedSpecialCharacters, notAllowedSpecialCharacters),
	hasLengthBetween(3, 100),
];

export const administrationName = [
	notAllowedCharacters(regexAdministration, allowedCharactersAdministration),
	hasLengthBetween(2, MaxLengths.SURNAME),
	allowedNumberOfAsterisk(1),
	asteriskAfterThreeSymbols(),
];

export const clientBirthNumber = [
	notAllowedCharacters(regexNumber, allowedOnlyNumbers),
	hasLengthBetween(9, 10, lengthBetweenNumber),
];
// Only for modal 561
export const birthNumberTaxNumber = [notAllowedCharacters(regexNumber, allowedOnlyNumbers), hasLengthBetween(8, 10)];

export const businessCaseNumber = [
	exactLength(16),
	notAllowedCharactersFromTo(regexNumber, allowedCharactersBusinessCase, 1, 15),
	allowedLastCharacterNumberOrLetter(regexNumber, allowedCharactersBusinessCase, businessCaseLastCharacter, 16),
	checkValidBusinessCaseNumber(allowedCharactersBusinessCase),
];

export const zipCode = [notAllowedCharacters(regexZipCode, allowedCharacters)];

export const taskId = [notAllowedCharacters(regexNumber, allowedOnlyNumbers)];

export const municipality = [
	notAllowedCharacters(regexMunicipality, allowedCharactersMunicipality),
	hasLengthBetween(2, 55),
];

export const street = [notAllowedCharacters(regexMunicipality, allowedCharactersStreet), hasLengthBetween(2, 100)];

export const streetNo = [
	notAllowedCharacters(regexStreetNumber, allowedCharactersStreetNumber),
	hasLengthBetween(1, 50),
];

export const productPP = [
	decimalLength(2, allowedCharactersProductPP),
	isDecimalNumberNotGreaterThan(99999999, allowedCharactersProductPP),
];

// businessIn
export const taxNumber = [notAllowedCharacters(regexNumber, allowedOnlyNumbers)];

export const phoneNumber = [
	notAllowedCharacters(regexPhoneNumber, allowedCharactersPhoneNumber),
	hasLengthBetween(9, 14),
];

export const email = [
	notAllowedCharacters(emailRegExp, allowedCharactersEmail),
	domainMaxLength(61, allowedCharactersEmail),
	hasLengthBetween(0, 254, lengthMax),
];

export const dayMonth = [
	notAllowedCharacters(regexDate, allowedCharactersDate),
	hasLengthBetween(4, 5),
	dayMonthValid(wrongFormatWithExample),
];

export const dayMonthsWithOrder = (from, to) => dayMonth.concat(dayMonthsOrder(from, to));

export const year = [
	notAllowedCharacters(regexNumber, allowedOnlyNumbers),
	exactLength(4, lengthExactUnderFour),
	yearValid(wrongFormat),
];

export const yearWithOrder = (from, to) => year.concat(yearsOrder(from, to));

// ASYNC VALIDATIONS

const asyncCheckPS = (msg) => ({
	functionName: 'asyncCheckPS',
	args: {
		msg,
	},
	severity: constants.severity.WARNING,
});

export const PSNumberSoft = [asyncCheckPS(wrongPSNumber)];

export const policyFrameworkNo = [notAllowedCharacters(regexNumber, allowedCharacters), hasLengthBetween(8, 22)];

export const carRegNo = [
	notAllowedCharacters(regexDocumentId, allowedOnlyNumbersAndCharacters),
	hasLengthBetween(5, 10),
];
